import { Component } from '@angular/core';

@Component({
  selector: 'app-return-and-refund-policy',
  imports: [],
  templateUrl: './return-and-refund-policy.html',
  styleUrl: './return-and-refund-policy.scss'
})
export class ReturnAndRefundPolicy {

}
